<section class="curation-editor-wrapper curation-editor-wrapper-report" *ngIf="isDataLoaded">
  <gen-overlay-loader *ngIf="loading" class="curation-editor-overlay-loader"></gen-overlay-loader>
  <gen-curation-editor-header
    [curationItem]="curationItem"
    [curationStatus]="curationStatus"
    [revisionsData$]="revisionsData"
    [revisionName]="currentRevisionName"
    [readOnlyUserMode]="readOnlyUserMode"
    (revisionSelected)="revisionHistoryRowClick($event)"
    [revisionLastUpdatedDate]="revisionLastUpdatedDate"
    [lastManualOpinionName]="lastManualOpinionName"
  >
  </gen-curation-editor-header>
  <gen-curation-editor-actions
    [curationStatus]="curationStatus"
    [curationKey]="curationKey"
    [approvalUserMode]="approvalUserMode"
    [publishUserMode]="publishUserMode"
    [curatorUserMode]="curatorUserMode"
    [isAssignee]="isCurationItemAssignedToCurrentUser"
    [buttonsDisabled]="actionsDisabledMode"
    [curationItem]="curationItem"
    [oldRevisionMessage]="oldRevisionMessage"
    [readOnlyUserMode]="readOnlyUserMode"
    [multiStepReview]="multiStepReview"
    [newNotes]="newNotes"
    [reassignButtonDisabled]="isReassignButtonDisabled"
    [historyData]="revisionsData"
    (statusChanged)="changeStatus($event.status)"
    (statusChangedToRejected)="reject()"
    (goBackEvent)="goBack(true)"
    (notesPanelToggled)="toggleNotesPanel()"
    (toggleReassignCurationItem)="reassignCurationItem()"
    (toggleSubmitCurationItemForReview)="submitCurationItemForReview()"
    [sameOrganization]= "sameOrganization"
    [showStopWorkflowButton] = "showStopWorkflowButton"
    [showArchiveReason] = "showArchiveReason"
    (toggleShowArchiveReason)="viewArchiveReason()"
  >
  </gen-curation-editor-actions>
  <gen-panel
          name="CURATION-NOTES-PANEL"
          class="{{notesPanelClass}}"
          (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)">
  </gen-panel>

  <!--The following condition should be handled more generically-->
  <ng-container *ngIf="formData.type && formData.type!=='clinical_trial'">
  
  <section class="scrollable curation-editor-content-and-viewer" style="width:100%">
    <section class="curation-editor-content override-item-as-column" [ngClass]="curationStatus" *ngIf="isDataLoaded">
      <gen-dynamic-form
        [listenToDataChange]="true"
        [formData]="formData"
        [formName]="formName"
        [formVertical]="true"
        [updateOnBlur]="false"
        [updatedFieldsContext]="updatedFieldsContext"
        [submitted]="submitted"
        [editMode]="true"
        (formChange)="updateForm($event.form)"
        [disabledFields]="disabledField"
        (validateChange)="validationEvent($event)"
        (linkClick)="downloadApprovalPDF($event)"
      >
      </gen-dynamic-form>
    </section>
    <section style="width:80%">
      <gen-overlay-loader *ngIf="!pdfFileNotUploaded"></gen-overlay-loader>
      <ng2-pdfjs-viewer [style.display]="showPdfViewer ? 'inline' : 'none'" [print]="false" [openFile]="false" #inlinePdfViewer></ng2-pdfjs-viewer>
    </section>
    </section>

  </ng-container>

  <!--Temporary solution for including trial curation-->
  <gen-trial-curation *ngIf="formData.type && formData.type=='clinical_trial' && isDataLoaded"
                     [trial]="curationItem.curationData['content']"
                     [curationStatus]="curationStatus"
  >
  </gen-trial-curation>

</section>
